import { render, staticRenderFns } from "./Cria_Uniodonto.vue?vue&type=template&id=2c65b7c6&"
import script from "./Cria_Uniodonto.vue?vue&type=script&lang=js&"
export * from "./Cria_Uniodonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports